module.exports = __webpack_public_path__ + "2c45ce66755b79d0d2e672000aa2fe96.svg";